export var VM_WARE_PRODUCT = {
  VmWareVirtualDataCenter: 'virtualDataCenter',
  VmWareCloudBackup: 'vmWareCloudBackup',
  VmWareVirtualMachinesBackup: 'vmWareVirtualMachinesBackup',
  VmWareVirtualWorkspaces: 'vmWareVirtualWorkspaces'
};